export const DEFAULT_POP_UP_SIZE = "width=350, height=500";
